import {axiosi} from '../../config/axios'
import { collection, addDoc , query, where, getDocs , getDoc , updateDoc , deleteDoc , doc , serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";

// export const addToCart=async(item)=>{
//     try {
//         const res=await axiosi.post('/cart',item)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

// export const fetchCartByUserId=async(id)=>{
//     try {
//         const res=await axiosi.get(`/cart/users/${id}`)
//         // return res.data
//     } catch (error) {
//         // throw error.response.data
//         return [
//             {
//                 "_id": "65c357fe2f21c40d167c276b",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "product": {
//                     "_id": "65a7e45902e12c44f5994453",
//                     "title": "MacBook Pro",
//                     "description": "MacBook Pro 2021 with mini-LED display may launch between September, November",
//                     "price": 1749,
//                     "discountPercentage": 11.02,
//                     "category": "65a7e24602e12c44f599442d",
//                     "brand": {
//                         "_id": "65a7e20102e12c44f59943da",
//                         "name": "Apple",
//                         "__v": 0
//                     },
//                     "stockQuantity": 83,
//                     "thumbnail": "https://cdn.dummyjson.com/product-images/6/thumbnail.png",
//                     "images": [
//                         "https://cdn.dummyjson.com/product-images/6/1.png",
//                         "https://cdn.dummyjson.com/product-images/6/2.jpg",
//                         "https://cdn.dummyjson.com/product-images/6/3.png",
//                         "https://cdn.dummyjson.com/product-images/6/4.jpg"
//                     ],
//                     "isDeleted": false,
//                     "updatedAt": "2024-02-07T09:22:57.840Z",
//                     "createdAt": "2025-11-29T16:22:52.594Z"
//                 },
//                 "quantity": 1
//             },
//             {
//                 "_id": "65c3581d2f21c40d167c278f",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "product": {
//                     "_id": "65a7e45902e12c44f599445d",
//                     "title": "Hyaluronic Acid Serum",
//                     "description": "L'OrÃ©al Paris introduces Hyaluron Expert Replumping Serum formulated with 1.5% Hyaluronic Acid",
//                     "price": 19,
//                     "discountPercentage": 13.31,
//                     "category": "65a7e24602e12c44f599442f",
//                     "brand": {
//                         "_id": "65a7e20102e12c44f59943e6",
//                         "name": "L'Oreal Paris",
//                         "__v": 0
//                     },
//                     "stockQuantity": 110,
//                     "thumbnail": "https://cdn.dummyjson.com/product-images/16/thumbnail.jpg",
//                     "images": [
//                         "https://cdn.dummyjson.com/product-images/16/1.png",
//                         "https://cdn.dummyjson.com/product-images/16/2.webp",
//                         "https://cdn.dummyjson.com/product-images/16/3.jpg",
//                         "https://cdn.dummyjson.com/product-images/16/4.jpg",
//                         "https://cdn.dummyjson.com/product-images/16/thumbnail.jpg"
//                     ],
//                     "isDeleted": false,
//                     "updatedAt": "2024-02-07T09:22:57.840Z",
//                     "createdAt": "2025-11-29T16:22:52.595Z"
//                 },
//                 "quantity": 4
//             },
//             {
//                 "_id": "65c3584f2f21c40d167c27f5",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "product": {
//                     "_id": "65a7e45902e12c44f59944a1",
//                     "title": "Square Sunglasses",
//                     "description": "Fashion Oversized Square Sunglasses Retro Gradient Big Frame Sunglasses For Women One Piece Gafas Shade Mirror Clear Lens 17059",
//                     "price": 28,
//                     "discountPercentage": 13.89,
//                     "category": "65a7e24602e12c44f599443c",
//                     "brand": {
//                         "_id": "65a7e20102e12c44f599441a",
//                         "name": "mastar watch",
//                         "__v": 0
//                     },
//                     "stockQuantity": 64,
//                     "thumbnail": "https://cdn.dummyjson.com/product-images/84/thumbnail.jpg",
//                     "images": [
//                         "https://cdn.dummyjson.com/product-images/84/1.jpg",
//                         "https://cdn.dummyjson.com/product-images/84/2.jpg",
//                         "https://cdn.dummyjson.com/product-images/84/thumbnail.jpg"
//                     ],
//                     "isDeleted": false,
//                     "updatedAt": "2024-02-07T09:22:57.840Z",
//                     "createdAt": "2025-11-29T16:22:52.602Z"
//                 },
//                 "quantity": 2
//             },
//             {
//                 "_id": "692b20d604589e4cdeca4bce",
//                 "user": "65b8e564ea5ce114184ccb96",
//                 "product": {
//                     "_id": "65a7e45902e12c44f599444f",
//                     "title": "Fog Scent Xpressio Perfume custom",
//                     "description": "Product details of Best Fog Scent Xpressio Perfume 100ml For Men cool long lasting perfumes for Men",
//                     "price": 13,
//                     "discountPercentage": 8.14,
//                     "category": "65a7e24602e12c44f599442e",
//                     "brand": {
//                         "_id": "65a7e20102e12c44f59943e3",
//                         "name": "Fog Scent Xpressio",
//                         "__v": 0
//                     },
//                     "stockQuantity": 21,
//                     "thumbnail": "https://cdn.dummyjson.com/product-images/13/thumbnail.webp",
//                     "images": [
//                         "https://cdn.dummyjson.com/product-images/13/1.jpg",
//                         "https://cdn.dummyjson.com/product-images/13/2.png",
//                         "https://cdn.dummyjson.com/product-images/13/3.jpg",
//                         "https://cdn.dummyjson.com/product-images/13/4.jpg"
//                     ],
//                     "isDeleted": false,
//                     "updatedAt": "2024-02-07T09:22:57.840Z",
//                     "createdAt": "2025-11-29T16:22:52.594Z"
//                 },
//                 "quantity": 1
//             },
//             // {
//             //     "_id": "692b28d748bd0d133f3e1902",
//             //     "user": "65b8e564ea5ce114184ccb96",
//             //     "product": {
//             //         "_id": "65a7e45902e12c44f599444e",
//             //         "title": "iPhone 9",
//             //         "description": "An apple mobile which is nothing like apple",
//             //         "price": 549,
//             //         "discountPercentage": 12.96,
//             //         "category": "65a7e24602e12c44f599442c",
//             //         "brand": {
//             //             "_id": "65a7e20102e12c44f59943da",
//             //             "name": "Apple",
//             //             "__v": 0
//             //         },
//             //         "stockQuantity": 14,
//             //         "thumbnail": "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg",
//             //         "images": [
//             //             "https://cdn.dummyjson.com/product-images/1/1.jpg",
//             //             "https://cdn.dummyjson.com/product-images/1/2.jpg",
//             //             "https://cdn.dummyjson.com/product-images/1/3.jpg",
//             //             "https://cdn.dummyjson.com/product-images/1/4.jpg",
//             //             "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg"
//             //         ],
//             //         "isDeleted": false,
//             //         "updatedAt": "2024-02-07T09:22:57.840Z",
//             //         "createdAt": "2025-11-29T16:22:52.593Z"
//             //     },
//             //     "quantity": 1
//             // }
//         ]
//     }
// }

// export const updateCartItemById=async(update)=>{
//     try {
//         const res=await axiosi.patch(`/cart/${update._id}`,update)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }
// export const deleteCartItemById=async(id)=>{
//     try {
//         const res=await axiosi.delete(`/cart/${id}`)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

// export const resetCartByUserId=async(userId)=>{
//     try {
//         const res=await axiosi.delete(`/cart/user/${userId}`)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }


// export const addToCart = async (item) => {
//     try {
//         console.log('item',item)

//         // quantity agar missing ho to default 1 assign karo
//         const payload = {
//             ...item,
//             quantity: item.quantity ?? 1,   // <-- DEFAULT QUANTITY
//             createdAt: serverTimestamp()   // <-- NEW FIELD
//         };

//         const ref = await addDoc(collection(db, "cart"), payload);
//         return { _id: ref.id, ...item };

//     } catch (error) {
//         throw { message: error.message };
//     }
// };

export const addToCart = async (item) => {
    try {
        // 1. Default quantity
        const payload = {
            ...item,
            quantity: item.quantity ?? 1,
            createdAt: serverTimestamp()
        };

        // 2. Add to Firestore
        const ref = await addDoc(collection(db, "cart"), payload);

        // 3. Fetch Product
        const productRef = doc(db, "products", item.product);
        const productSnap = await getDoc(productRef);

        let product = null;
        let brand = null;

        if (productSnap.exists()) {
            product = { _id: productSnap.id, ...productSnap.data() };

            // 4. Fetch Brand
            if (product.brand) {
                const brandRef = doc(db, "brands", product.brand);
                const brandSnap = await getDoc(brandRef);

                if (brandSnap.exists()) {
                    brand = { _id: brandSnap.id, ...brandSnap.data() };
                }
            }
        }

        // 5. Final response (MongoDB jaisa populate)
        return {
            _id: ref.id,
            user: item.user,
            quantity: payload.quantity,
            product: product ? { ...product, brand } : null
        };

    } catch (error) {
        console.log("Add to Cart Error:", error);
        throw { message: error.message };
    }
};


export const fetchCartByUserId = async (userId) => {
    try {
        // 1. User ke cart items fetch karo
        const q = query(collection(db, "cart"), where("user", "==", userId));
        const snap = await getDocs(q);

        const result = [];

        for (let cartDoc of snap.docs) {
            const cartData = cartDoc.data();

            // 2. Product fetch
            const productRef = doc(db, "products", cartData.product);
            const productSnap = await getDoc(productRef);
            
            let product = null;
            let brand = null;

            if (productSnap.exists()) {
                product = { _id: productSnap.id, ...productSnap.data() };
                
                
                // 3. Brand fetch (if available)
                if (product.brand) {
                    const brandRef = doc(db, "brands", product.brand);
                
                    const brandSnap = await getDoc(brandRef);
                   
                    if (brandSnap.exists()) {
                        brand = { _id: brandSnap.id, ...brandSnap.data() };
                        console.log("🔥 brand Result:", brand);  // <— HERE
                    }
                }
            }

            // 4. Final structure MongoDB populate jaisa
            result.push({
                _id: cartDoc.id,
                user: userId,
                color: cartData.color,
                size: cartData.size,
                product: product
                    ? {
                        ...product,
                        brand: brand || null
                    }
                    : null,
                quantity: cartData.quantity,
            });
        }

        console.log("🔥 Cart Result:", result);  // <— HERE
        return result;

    } catch (error) {
        console.log("Cart Fetch Error:", error);
        return [];
    }
};


export const updateCartItemById = async (update) => {
    try {
        const ref = doc(db, "cart", update._id);
        const { _id, ...payload } = update;

        await updateDoc(ref, payload);

        // Now fetch updated doc
        const snap = await getDoc(ref);
        const cartData = snap.data();

        // Fetch product
        const productSnap = await getDoc(doc(db, "products", cartData.product));
        let product = productSnap.exists()
            ? { _id: productSnap.id, ...productSnap.data() }
            : null;

        // Fetch brand
        let brand = null;
        if (product?.brand) {
            const brandSnap = await getDoc(doc(db, "brands", product.brand));
            brand = brandSnap.exists()
                ? { _id: brandSnap.id, ...brandSnap.data() }
                : null;
        }

        return {
            _id: snap.id,
            user: cartData.user,
            quantity: cartData.quantity,
            product: product ? { ...product, brand } : null,
        };

    } catch (error) {
        throw { message: error.message };
    }
};


export const deleteCartItemById = async (id) => {
    try {
        await deleteDoc(doc(db, "cart", id));
        return { message: "Item removed", _id: id };

    } catch (error) {
        throw { message: error.message };
    }
};

export const resetCartByUserId = async (userId) => {
    try {
        const q = query(collection(db, "cart"), where("user", "==", userId));
        const snap = await getDocs(q);

        const batchDeletes = snap.docs.map((d) => deleteDoc(doc(db, "cart", d.id)));
        await Promise.all(batchDeletes);

        return { message: "Cart cleared", user: userId };

    } catch (error) {
        throw { message: error.message };
    }
};